
export const SaveCancelButtons = ({
    testId,
    detached,
    saveOnClick,
    cancelOnClick,
}) => {
    return (
        <div className={`flex gap-2 ${detached ? "absolute": ""}`} data-testid={testId ? `wrapper-buttons-${testId}` : undefined}>
            <button 
                onClick={async () => {
                    saveOnClick()
                }} 
                data-testid={testId ? `${testId}_save_button` : undefined}
                className="text-green-600 hover:text-green-800"
            >
                Save
            </button>
            <button 
                onClick={() => {
                    cancelOnClick()
                }} 
                data-testid={testId ? `${testId}_cancel_button` : undefined}
                className="text-gray-600 hover:text-gray-800"
            >
                Cancel
            </button>
        </div>
    )
}